/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { LONG_DATE_ONLY_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography2 } from '@coursera/cds-core';

import Subsection from 'bundles/unified-description-page-common/components/shared/Subsection';
import type { FixedSessionFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedEnterpriseEntitiesFragments';

import _t from 'i18n!nls/xdp';

const styles = {
  availabilities: () => css`
    border: 1px solid var(--cds-color-grey-200);
    border-radius: 4px;
    display: inline-flex;
    padding: var(--cds-spacing-150) 0;
    margin: var(--cds-spacing-200) 0 0;

    li {
      padding: 0 var(--cds-spacing-200);
    }

    li + li {
      border-left: 1px solid var(--cds-color-grey-200);
    }
  `,
  label: css`
    font-weight: 600;
  `,
};

type Props = {
  fixedSession?: FixedSessionFragment | null;
};

const AvailabilityDetails = ({ fixedSession }: Props) => {
  if (!fixedSession) {
    return null;
  }

  return (
    <Subsection
      title={
        <Typography2 variant="subtitleMedium" component="h4">
          {_t('Availability details')}
        </Typography2>
      }
    >
      <Typography2 component="p" variant="bodyPrimary">
        {/* eslint-disable-next-line */}
        {_t("This course must be completed by its end date. You can't reset deadlines.")}
      </Typography2>
      <ul css={styles.availabilities}>
        <li>
          <Typography2 variant="bodySecondary" color="supportText" component="div" css={styles.label}>
            {_t('Available from')}
          </Typography2>
          <Typography2 variant="subtitleMedium" component="div">
            {formatDateTimeDisplay(fixedSession.startsAt, LONG_DATE_ONLY_DISPLAY)}
          </Typography2>
        </li>
        <li>
          <Typography2 variant="bodySecondary" color="supportText" component="div" css={styles.label}>
            {_t('Available until')}
          </Typography2>
          <Typography2 variant="subtitleMedium" component="div">
            {formatDateTimeDisplay(fixedSession.endsAt, LONG_DATE_ONLY_DISPLAY)}
          </Typography2>
        </li>
      </ul>
    </Subsection>
  );
};

export default AvailabilityDetails;
